// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Loading from 'react-loading';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

import '../../styles/investments.css';

// Register the necessary components for a Doughnut chart
ChartJS.register(ArcElement, Tooltip, Legend);

export default class DoughnutChart extends React.Component {
    render = () => {
        return (<div className="investments-chart"
            style={{...(this.props.styles || {})}}
        >
            <h3>{this.props.title}</h3>
            <div
                className="investments-chart-container"
                style={{
                    backgroundColor: this.props.data === undefined ? 'var(--color-menu-raised)' : 'transparent'
                }}
            >
                {this.props.data === undefined ? <div className="investments-chart-loading">
                    <Loading
                        type="bubbles"
                        color="var(--color-primary)"
                        height={32}
                        width={32}
                    />
                </div> : <Doughnut
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                display: true,
                                position: 'right'
                            }
                        }
                    }}
                    data={{
                        labels: this.props.labels,
                        datasets: [{
                            label: 'Dataset 1',
                            data: this.props.data,
                            backgroundColor: this.props.colors,
                            hoverOffset: 4
                        }]
                    }}
                />}
            </div>
        </div>);
    }
}
